import ReactGA from 'react-ga4'

export const GA_MEASUREMENT_ID = 'G-9RJSSKJ9FR'

export function initGA() {
  if (typeof window === 'undefined') {
    return false
  }
  if (window.GA_INITIALIZED) {
    return true
  }
  if (!GA_MEASUREMENT_ID || GA_MEASUREMENT_ID === 'G-TU-ID-AQUI') {
    console.warn('GA_MEASUREMENT_ID no está configurado. Reemplázalo por tu ID real.')
    return false
  }
  ReactGA.initialize(GA_MEASUREMENT_ID)
  window.GA_INITIALIZED = true
  return true
}

export function logPageView(pathname) {
  if (typeof window === 'undefined' || !window.GA_INITIALIZED) {
    return
  }
  const pagePath =
    pathname || `${window.location.pathname}${window.location.search}${window.location.hash}`
  const pageLocation = `${window.location.origin}${pagePath}`
  const pageTitle = document?.title

  ReactGA.set({
    page: pagePath,
    page_path: pagePath,
    page_location: pageLocation,
  })

  ReactGA.send({
    hitType: 'pageview',
    page: pagePath,
    page_path: pagePath,
    page_location: pageLocation,
    title: pageTitle,
    page_title: pageTitle,
  })

  if (process.env.NODE_ENV !== 'production') {
    console.debug('[GA4] page_view', {
      page: pagePath,
      title: pageTitle,
    })
  }
}
